import { components } from 'gridstrap/lib/gs-components';
import { GSFormHidden } from './form-hidden';

components.register({
	selector: '.gs-FormHidden',
	controller: GSFormHidden
});
